import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { WorkplaceGroupFragment } from '@api/fragments'
import { IWorkplaceGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateWorkplaceGroup: { workplaceGroup: IWorkplaceGroup }
}

const mutation = gql`
  mutation UpdateWorkplaceGroupMutation($input: UpdateWorkplaceGroupInput!) {
    updateWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.updateWorkplaceGroup.workplaceGroup,
  name: 'Update Color',
})

export default function updateWorkplaceGroupColor({
  workplaceGroupId,
  color,
}: {
  workplaceGroupId: string
  color: string
}): Promise<IWorkplaceGroup> {
  const input = {
    id: workplaceGroupId,
    color,
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}
